import Vue from 'vue'
import Vuex from 'vuex'
// vue-cookies配置
import VueCookies from 'vue-cookies'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        navList: [], // 菜单数据
        menuList: [], // 当前选中的二级菜单数据
        buttonData: {}, // 按钮权限数据
        menuItem: VueCookies.get('menuItem') || {}, // 当前激活菜单的item
        activePath: VueCookies.get('activePath') || '',
        userInfo: VueCookies.get('userInfo') ? VueCookies.get('userInfo') : {},
        activeIndex: VueCookies.get('activeIndex') ? VueCookies.get('activeIndex') : 0,
        isCollapse: false, // 菜单折叠状态
        showPopover: true, // 悬浮菜单显隐
        tagsView: {},
        permission: {},
        settings: {},
        tabList: [] // tab 标签页记录
    },
    getters: {},
    mutations: {
        // 更新菜单折叠状态
        renewCollapse(state, status) {
            state.showPopover = !status
            state.isCollapse = status
        },
        // 更新悬浮菜单显隐
        renewShowPopover(state, status) {
            state.showPopover = status
        },
       
        // 更新菜单列表
        renewNavList(state, data) {
            state.navList = data
        },
        // 更新菜单列表
        renewMenuList(state, data) {
            state.menuList = data
        },
        // 更新按钮权限数据
        renewButtonData(state, data) {
            state.buttonData = data
        },
        // 更新激活菜单对象
        renewMenuItem(state, data) {
            state.menuItem = data
        },
        // 修改左侧菜单栏路径
        changeActivePath(state, path) {
            state.activePath = path
        },
        // 修改顶部菜单栏索引
        changeActiveIndex(state, index) {
            state.activeIndex = index
        },
        // 更新用户信息
        renewUserInfo(state, data) {
            state.userInfo = data
        },
        // 更新菜单折叠状态
        renewCollapse(state, status) {
            state.isCollapse = status
        },
        // 更新 tab 标签页记录
        renewTabList(state, data) {
            state.tabList = data
        }
    },
    actions: {},
    modules: {}
})
